import cn from 'classnames';
import IconDropdown from '@/assets/icons/icon-dropdown.svg';

import { Text } from '@/ui-components/atoms/Text/Text';
import { CSSProperties, ReactNode } from 'react';
import styles from './popoverwrapper.module.scss';
import { ShadowBox } from '@/ui-components/atoms/ShadowBox/ShadowBox';

interface PopoverWrapperProps {
    contentPadding: string;
    headerContent: ReactNode;
    closeButtonColor?: string;
    closeButtonContentOverride?: ReactNode;
    onClosePress: () => void;
    children: ReactNode;
    className?: string;
    ariaLabel?: string;
}

export default function PopoverWrapper({
    contentPadding,
    headerContent,
    closeButtonColor,
    closeButtonContentOverride,
    onClosePress,
    children,
    className,
    ariaLabel,
}: PopoverWrapperProps): React.JSX.Element {
    const styleVariables = {
        '--close-button-color': closeButtonColor,
        '--content-padding': contentPadding,
    } as CSSProperties;

    return (
        <ShadowBox targetClass={cn(styles.outerWrapper, className)}>
            <div className={styles.contentWrapper} style={styleVariables} data-cy="molecules-popover-wrapper">
                <button className={styles.button} onClick={() => onClosePress()} aria-label={ariaLabel}>
                    {closeButtonContentOverride ?? (
                        <>
                            <Text tag="div" className={styles.headerContent}>
                                {headerContent}
                            </Text>
                            <IconDropdown className={styles.defaultButton} />
                        </>
                    )}
                </button>

                <div className={styles.body}>{children}</div>
            </div>
        </ShadowBox>
    );
}
